import {createPinia, PiniaVuePlugin} from "pinia";
import piniaPersist from 'pinia-plugin-persistedstate'

window.Vue = require('vue');
window.axios = require('axios');
window.lodash = require('lodash');

import vmodal from 'vue-js-modal'
Vue.use(vmodal);

import GmapVue from 'gmap-vue'
import { components } from 'gmap-vue';
Vue.use(GmapVue, {
    load: {
        key: drupalSettings.ef2_custom.google_maps_api_key,
        libraries: 'places',
        region: 'NL',
        language: 'nl'
    },
})

Vue.component('gmap-cluster', components.Cluster);

import Toaster from 'v-toaster';
import 'v-toaster/dist/v-toaster.css';
Vue.use(Toaster, {timeout: 4000});

import VueMq from 'vue-mq'
Vue.use(VueMq, {
    breakpoints: {
        mobile: 768,
        tablet: 1024,
        laptop: 1250,
        desktop: Infinity,
    }
});

import VueCookies from 'vue-cookies';
Vue.use(VueCookies);
Vue.$cookies.config('1y');

import vSelect from 'vue-select';
Vue.component('v-select', vSelect);
import 'vue-select/dist/vue-select.css';

import PerfectScrollbar from 'vue2-perfect-scrollbar';
import 'vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css';
Vue.use(PerfectScrollbar);

import VShowSlide from 'v-show-slide';
Vue.use(VShowSlide);

import VueYoutube from 'vue-youtube';
Vue.use(VueYoutube);

import VCalendar from 'v-calendar';
Vue.use(VCalendar, {
    componentPrefix: 'vc',
});

Vue.use(PiniaVuePlugin)
const pinia = createPinia()
pinia.use(piniaPersist)

Vue.component('headroom-wrapper', require('../vue/components/HeadroomWrapper').default);
Vue.component('accordion', require('../vue/components/Accordion').default);
Vue.component('product-carousel', require('../vue/components/productCarousel').default);
Vue.component('carprof-finder', require('../../../../../modules/custom/carprof_base/js/components/CarprofFinder2').default);
Vue.component('active-garage-block', require('../../../../../modules/custom/carprof_garages/js/components/ActiveGarageBlock').default);
Vue.component('mobile-active-garage-block', require('../../../../../modules/custom/carprof_garages/js/components/MobileActiveGarageBlock').default);

Vue.component('review-block', require('../../../../../modules/custom/carprof_klantenvertellen/js/components/ReviewBlock').default);
Vue.component('review-block-small', require('../../../../../modules/custom/carprof_klantenvertellen/js/components/ReviewBlockSmall').default);
Vue.component('review-block-vestiging', require('../../../../../modules/custom/carprof_klantenvertellen/js/components/ReviewBlockVestiging').default);

Vue.component('occasion-overview', require('../../../../../modules/custom/carprof_occasions/js/components/OccasionOverview').default);
Vue.component('occasion-overview-step-one', require('../../../../../modules/custom/carprof_occasions/js/components/OccasionOverviewStepOne').default);
Vue.component('occasion-filter-group', require('../../../../../modules/custom/carprof_occasions/js/components/OccasionFilterGroup').default);
Vue.component('occasion-dropdown-filter', require('../../../../../modules/custom/carprof_occasions/js/components/OccasionDropdownFilter').default);
Vue.component('occasion-dropdown-range-filter', require('../../../../../modules/custom/carprof_occasions/js/components/OccasionDropdownRangeFilter').default);
Vue.component('occasion-range-filter', require('../../../../../modules/custom/carprof_occasions/js/components/OccasionRangeFilter').default);
Vue.component('occasion-list-item', require('../../../../../modules/custom/carprof_occasions/js/components/OccasionListItem').default);
Vue.component('loader', require('../../../../../modules/custom/carprof_occasions/js/components/Loader').default);

Vue.component('iframe-modal-button', require('../vue/components/IframeModalButton').default);
Vue.component('iframe-modal', require('../vue/components/IframeModal').default);
Vue.component('cp-youtube-wrapper', require('../vue/components/YoutubeWrapper.vue').default);

Vue.component('cp-navigation', require('../vue/components/Navigation').default);
Vue.component('cp-navigation-list', require('../vue/components/NavigationList').default)

Vue.component('cp-garage-select', require('../vue/components/GarageSelect').default);
Vue.component('cp-initials-carprof', require('../vue/components/svg/InitialsCarprof').default);
Vue.component('cp-planner-iframe', require('../vue/components/PlannerIframe').default);
Vue.component('cp-leadgen-garage-select', require('../vue/components/LeadgenGarageSelect').default);

Vue.component('cp-modal-block', require('../vue/components/ModalBlock').default);
Vue.component('cp-vacancy-overview', require('../vue/components/Vacancies/VacancyOverview').default);
Vue.component('cp-appointment-wrapper', require('../vue/components/Appointment/Wrapper').default);

new Vue({
    'el': '#page-wrapper',

    comments: true,

    pinia,

    data() {
        return {
            modalBus: new Vue()
        }
    },

    mounted() {
        let plannerButtons = document.querySelectorAll(".page-node-type-specialismes a[href^='https://planner.garage.software'], .page-node-type-specialismes a[href^='https://cwp3.cartel.nl'], .page-node-type-specialismes a[href^='https://www.autoflex10.nl'], .page-node-type-specialismes a[href^='https://www.jwdevoogd.nl'], .page-node-type-specialismes a[href^='https://www.autoservicehuls.nl'], .page-node-type-specialismes a[href^='https://www.citapreviadirecta.com']");

        if (!_.isEmpty(plannerButtons)) {
            Array.from(plannerButtons).forEach(button => {
                let planLink = button.getAttribute('href');

                button.onclick = () => {
                    this.modalBus.$emit('show-iframe-modal', {
                        iframeSrc: planLink
                    });

                    return false;
                }
            });
        }
    }
});

(function ($, Drupal) {
    Drupal.behaviors.webformAjaxModal = {
        attach: function (context, settings) {
            if (!lodash.isNil(context.classList) && (context.classList.contains('webform-ajax-form-wrapper') || context.classList.contains('webform-submission-form'))) {
                if (lodash.isNil(document.querySelector('.webform-element-vue-wrapper'))) {
                    return;
                }

                new Vue({
                    'el': '.webform-element-vue-wrapper',
                });
            }
        }
    };
})(jQuery, Drupal);
